import React, { FC } from 'react';

import MachinesProvider from '@v2/pages/machines/common/providers/MachinesProvider/MachinesProvider';
import { TimelineItemsList } from '@v2/pages/machines/modules/timeline/components/TimelineItemsList/TimelineItemsList';
import { View } from 'react-native';
import { MACHINES_PAGES_CONTAINER_STYLES, SCREEN_PADDING_HORIZONTAL_FOR_PAGE } from '@v2/pages/common/constants/base.constants';
import { scale } from '@components/frame';
import MultiMachineTimeline from '@v2/pages/common/components/MultiMachineTimeline';

interface PartTimelineProps {}

const PartTimeline: FC<PartTimelineProps> = () => {
  return (
    <MachinesProvider
      // lg={lg}
      panelViewMode={false} //TODO: remove this later
      onBack={() => {}}
      getList={(props) => <TimelineItemsList {...props} />}
      withDefaultComponent
    >
      <View style={[MACHINES_PAGES_CONTAINER_STYLES, { paddingHorizontal: scale(SCREEN_PADDING_HORIZONTAL_FOR_PAGE) }]}>
        <MultiMachineTimeline withScroll={false} fullScreen={false} />
      </View>
    </MachinesProvider>
  );
};

export { PartTimeline };
